"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
const AmazonConnect = ({
  auth,
  customerName,
  styles,
  widgetId,
  snippetId,
  amazonConnectURL
}) => {
  const loadScript = (0, _react.useCallback)(() => {
    if (typeof window !== 'undefined') {
      (function (w, d, x, id) {
        const s = d.createElement('script');
        s.src = amazonConnectURL;
        s.async = 1;
        s.id = id;
        d.getElementsByTagName('head')[0].appendChild(s);
        w[x] = w[x] || function (...args) {
          (w[x].ac = w[x].ac || []).push(args);
        };
      })(window, document, 'amazon_connect', widgetId);
      window.amazon_connect('styles', styles || {
        openChat: {
          color: 'white',
          backgroundColor: '#DAFAFC'
        },
        closeChat: {
          color: 'white',
          backgroundColor: '#DAFAFC'
        }
      });
      window.amazon_connect('snippetId', snippetId);

      /**
       * Optional settings
       * window.amazon_connect('supportedMessagingContentTypes', ['text/plain', 'text/markdown']);
       *
       */
      if (customerName) {
        window.amazon_connect('customerDisplayName', callback => {
          callback(customerName);
        });
      }
      // eslint-disable-next-line require-await
      window.amazon_connect('authenticate', async callback => {
        callback(auth);
      });
    }
  }, [amazonConnectURL, auth, customerName, snippetId, styles, widgetId]);
  (0, _react.useEffect)(() => {
    loadScript();
  }, [loadScript]);
  return null;
};
AmazonConnect.propTypes = {
  auth: _propTypes.default.string.isRequired,
  customerName: _propTypes.default.string,
  styles: _propTypes.default.shape({
    openChat: _propTypes.default.shape({
      color: _propTypes.default.string,
      backgroundColor: _propTypes.default.string
    }),
    closeChat: _propTypes.default.shape({
      color: _propTypes.default.string,
      backgroundColor: _propTypes.default.string
    })
  }),
  widgetId: _propTypes.default.string,
  snippetId: _propTypes.default.string,
  amazonConnectURL: _propTypes.default.string
};
var _default = exports.default = AmazonConnect;